import React, { Component } from "react";
import "./AddToPlaylistMenu.scss";
import MusicTrackState from "../MusicTrackState";
import SearchState from "../../../SearchState";

/** @typedef {import("../../../../sql/schemaDatatypes").SavedPlaylistSql} SavedPlaylistSql */

/**
 * @typedef {Object} AddToPlaylistMenuProps
 * @property {() => void} onClose - Function to close the menu
 * @property {() => void} addToNewSearch - Function to add to new search
 * @property {Array<SavedPlaylistSql>} existingSearches - Array of existing playlists
 * @property {(search: SavedPlaylistSql) => void} addToExistingSearch - Function to add to existing search
 * @property {(track: MusicTrackState) => void} removeFromExistingPlaylist - Function to remove from playlist
 * @property {(track: MusicTrackState) => void} trackBelongsToCurrentPlaylist - Function to check track membership
 * @property {SearchState} store - The search state store
 * @property {MusicTrackState} track - The music track
 * @property {boolean} isLastTrack - Whether this is the last track in the list
 */

class AddToPlaylistMenu extends Component {
  /**
   * @param {AddToPlaylistMenuProps} props
   */
  constructor(props) {
    super(props);
    this.state = {
      menuAbove: false,
    };
    this.menuRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("mousedown", this.onMouseDown);
    this.adjustMenuPosition();
    window.addEventListener("resize", this.adjustMenuPosition);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.onMouseDown);
    window.removeEventListener("resize", this.adjustMenuPosition);
  }

  adjustMenuPosition = () => {
    if (!this.menuRef.current) return;

    const rect = this.menuRef.current.getBoundingClientRect();
    const menuBottom = rect.bottom;
    const viewportHeight = window.innerHeight;
    const buffer = 10;

    if (menuBottom + buffer > viewportHeight) {
      this.setState({ menuAbove: true, isLastTrack: this.props.isLastTrack });
    } else {
      this.setState({ menuAbove: false, isLastTrack: this.props.isLastTrack });
    }
  };

  /**
   * @param {string} trackName
   */
  copyTrackLink = (trackName) => {
    const url = `${
      window.location.origin
    }/en/single_keyword_search/?${encodeURIComponent(`${trackName}`)}`;
    this.props.store.getShortLink(url);
  };

  onMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.removeEventListener("mousedown", this.onMouseDown);
    this.props.onClose();
  };

  render() {
    let deleteFromPlaylist = null;
    if (this.props.store.trackBelongsToCurrentPlaylist(this.props.track)) {
      deleteFromPlaylist = (
        <div
          className={"AddToPlaylistMenu-choice"}
          onMouseDown={(e) => {
            this.props.removeFromExistingPlaylist(this.props.track);
            e.stopPropagation();
          }}
        >
          delete from this playlist
        </div>
      );
    }
    let childTray = null;

    const existingSearches = this.props.existingSearches.map(
      (search) => (
        <div
          className={"AddToPlaylistMenu-choice"}
          key={search.id}
          onMouseDown={(e) => {
            this.props.addToExistingSearch(search);
            this.onMouseDown(e);
          }}
        >
          {search.name}
        </div>
      )
    );

    childTray = (
      <div className={"AddToPlaylistMenu-menu AddToPlaylistMenu-choices-tray"}>
        <div
          className={"AddToPlaylistMenu-choice"}
          onMouseDown={this.props.addToNewSearch}
        >
          new playlist
        </div>
        <hr className={"AddToPlaylistMenu-hr"} />
        <div
          className={"AddToPlaylistMenu-choice-tray"}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
        >
          {existingSearches}
        </div>
      </div>
    );

    let addToPlaylistOption;
    if (this.props.store.loggedIn) {
      addToPlaylistOption = (
        <div>
          <div className={"AddToPlaylistMenu-choice"}>
            add to existing playlist
            <div className={"AddToPlaylistMenu-right-triangle"} />
            {childTray}
          </div>
        </div>
      );
    } else {
      addToPlaylistOption = (
        <div>
          <div
            className={"AddToPlaylistMenu-choice"}
            onMouseDown={(e) => {
              e.stopPropagation();
              this.props.track.download();
            }}
          >
            add to existing playlist
          </div>
        </div>
      );
    }

    return (
      <div className={"AddToPlaylistMenu"}>
        <div 
          className={`AddToPlaylistMenu-menu ${this.state.menuAbove ? 'AddToPlaylistMenu-menu--above' : ''} ${this.state.menuAbove && this.state.isLastTrack ? 'AddToPlaylistMenu-menu--last-track' : ''}`}
          ref={this.menuRef}
        >
          {addToPlaylistOption}
          {deleteFromPlaylist}
          <div
            className={"AddToPlaylistMenu-choice"}
            onMouseDown={() =>
              this.props.store.searchSimilarTracks(this.props.track)
            }
            // onMouseDown={() => this.props.store.searchTopTags(this.props.track)}
          >
            find similar tracks
          </div>
          <div
            className={"AddToPlaylistMenu-choice"}
            onMouseDown={() =>
              this.props.store.showRelevantTags(this.props.track)
            }
          >
            show relevant tags
          </div>
          <div
            className={"AddToPlaylistMenu-choice"}
            onMouseDown={() => {
              this.props.store.setShortlinkType("track");
              this.copyTrackLink(this.props.track.music.name.toLowerCase());
            }}
          >
            get track link
          </div>
        </div>
        <div
          className={"AddToPlaylistMenu-blanket"}
          onMouseDown={this.onMouseDown}
        />
      </div>
    );
  }
}

export default AddToPlaylistMenu;
